<template>
  <el-container class="custom">
    <el-footer style="margin-top:20px">
      <div style="text-align: center; display: none;   color: #fff;">{{ formlist.enterpriseName }}</div>

      <!-- <el-carousel height="200px">
        <el-carousel-item v-for="(item, index) in src" :key="index">
          <a :href="item.link">
            <el-image :src="decodeURIComponent(item.url)" style="width: 100%; height: 100%" fit="fill"></el-image>
          </a>
        </el-carousel-item>
      </el-carousel> -->
      <el-image style="display: none; padding: 35px;" :src="require(`@/assets/img/stproduct.png`)"
                :preview-src-list="[require(`@/assets/img/stproduct.png`)]" fit="scale-down">
        <div slot="error" class="image-slot" style="text-align: center">
          <i class="el-icon-picture-outline" style="font-size: 46px"></i>
        </div>
      </el-image>
    </el-footer>
    <el-row style="  margin-top: 102vh">
      <el-col :span="22" :offset="1">
        <!-- 第一次扫到正品码 -->
        <el-form ref="formlist" :model="formlist" style="text-align: left;    font-size: 10px;" v-if="dialogVisible"
                 class="mainform" center>
          <!-- 溯源信息 -->
          <div class="suyuan" style="    padding-bottom: 50px;">
            <h2 style="text-align: center;    margin-top: 10px; ">{{ formlist.product_name }}</h2>
            <div class="hater">溯源信息</div>
            <el-divider></el-divider>
            <div
                style="    background-color: #e0e0e0;
                 padding: 10px;
                     font-size: 16px;
                font-weight: 600;
                 color: #e43846;"
            >
              {{ "该产品是" + formlist.enterpriseName + "生产的官方正品！" }}
            </div>
            <!-- <el-form-item label="产品图片:" label-width="85px" v-if="productimg"></el-form-item>
            <el-form-item label-width="80px" v-if="productimg">
              <div>
                <el-image style="width: 80px; height: 60px" :src="decodeURIComponent(formlist.productPic)" :preview-src-list="[decodeURIComponent(formlist.productPic)]" fit="scale-down">
                  <div slot="error" class="image-slot" style="text-align: center">
                    <i class="el-icon-picture-outline" style="font-size: 46px"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item> -->
            <el-form-item label="产品名称:">
              <div>{{ formlist.product_name }}</div>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="产品编码:"></el-form-item>
                <div>{{ formlist.product_code }}</div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="追溯编码:"></el-form-item>
                <div>{{ formlist.qrcode }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="首次扫码时间:"></el-form-item>
                <div>{{ formlist.create_time }}</div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="扫码次数:"></el-form-item>
                <div>{{ formlist.count }}</div>
              </el-col>
            </el-row>

            <!-- <div v-for="(item, i) in formlist.wlist" :key="i" class="text item" style="color: #000">
              {{ `${item.columnTitle}：${item.columnValue}` }}
            </div> -->
          </div>
          <div style=" background-color: #fff; display: flex;">
            <div class="leftyuan"></div>
            <div class="dashed-border"></div>
            <div class="rightyuan"></div>
          </div>

          <div class="suyuan2">
            <el-form-item label="生产厂家:" v-if="obj.enterpriseName == 'true'">
              <div>{{ formlist.enterpriseName }}</div>
            </el-form-item>
            <el-form-item label="生产批次:" v-if="obj.batchNo == 'true'">
              <div>{{ formlist.batchNo }}</div>
            </el-form-item>
            <el-divider></el-divider>
            <div
                style="color: red;
    font-weight: 600;
    font-size: 10px;    margin: 10px 0;"
            >
              您查询的是消费者扫产品的包装箱码，该产品相关信息如下:
            </div>
            <el-table border :data="formlist.extendList" style="width: 100%">
              <el-table-column prop="columnTitle" label="产品信息"></el-table-column>
              <el-table-column prop="columnValue" label></el-table-column>
            </el-table>
          </div>

          <!-- <el-card shadow="hover" class="fanwei" v-if="formlist.qrcodeFlows===null ? false:formlist.qrcodeFlows.length>0">
            <div slot="header" class="clearfix">
              <h4>物流信息</h4>
            </div>
            <el-form-item label="配送物流">
              <div v-show="formlist.hasfreightBillCode">
                {{ formlist.enterpriseName }}{{ formlist.from_warehouse }}出到{{
                  formlist.to_warehouse
                }}
              </div>
              <br />
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(item, index) in formlist.qrcodeFlows"
                  :key="index"
                  :timestamp="item.createTime"
                >
                  <div>单号：{{ item.orderNo }}</div>
                  <div>物流类型：{{ item.type }}</div>
                  <div>发货方：{{ item.shipper }}</div>
                  <div>发货地址：{{ item.shipperAddress }}</div>
                  <div>收货方：{{ item.shipto }}</div>
                  <div>收货地址：{{ item.shiptoAddress }}</div>
                </el-timeline-item>
              </el-timeline>
            </el-form-item>
          </el-card> -->
          <!-- 企业简介 -->
          <div class="imfodiv">
            <div class="titleyuan">
              <div class="yuanred"></div>
              产品基本信息及特征
            </div>
            <div style="    color: #696969;font-weight: 600;margin-bottom: 5px;">水塔420mL红盖陈酷</div>
            <div>产品特征:山西风味，酸香绵鲜，传统工艺，纯粮酿造。本品可直接用于各种烹饪，也可直接蘸拌使用。</div>
            <div style="margin-top:5px">
              推荐应用:酸辣、酸甜菜系，凉拌菜系，点蘸美食，亦可作为复合 调料基础原料。
            </div>
          </div>
          <div class="imfodiv">
            <div class="titleyuan">
              <div class="yuanred"></div>
              企业简介
            </div>
            <div style="line-height: 22px;">
              山西水塔醋业股份有限公司始创于1976年，位于“中国醋都”山西省清徐县，是国家八部委命名的全国农业产业化重点龙头企业，也是目前国内大型的老陈醋生产企业。现有职工2000余人，厂区占地面积1500亩，拥有3万亩酿醋专用高梁基地。现已形成集原料基地、科研开发、制曲酿造、包装运输、营销策划、旅游文化于一体的企业集团。
            </div>
            <el-image :src="require(`@/assets/img/stbg01.png`)" :preview-src-list="[require(`@/assets/img/stbg01.png`)]"
                      fit="scale-down">
              <div slot="error" class="image-slot" style="text-align: center">
                <i class="el-icon-picture-outline" style="font-size: 46px"></i>
              </div>
            </el-image>
          </div>
          <div class="imfodiv" style="te">
            <div class="titleyuan">
              <div class="yuanred"></div>
              水塔醋业公众号二维码
            </div>
            <div style="text-align: center;">
              <el-image style="margin: 20px;width: 150px;" :src="require(`@/assets/img/stcode.png`)"
                        :preview-src-list="[require(`@/assets/img/stcode.png`)]" fit="scale-down">
                <div slot="error" class="image-slot" style="text-align: center">
                  <i class="el-icon-picture-outline" style="font-size: 46px"></i>
                </div>
              </el-image>
            </div>
          </div>
          <div>
            <!-- <el-footer>
              <a :href="link2">
                <el-image :src="decodeURIComponent(photo2)" style="width: 100%; height: 100%"></el-image>
              </a>
            </el-footer> -->
          </div>
        </el-form>
        <!-- 扫到假货 -->
        <el-form ref="formlist" :model="formlist" label-width="140px" v-if="Visible" class="mainform">
          <div>系统维护中</div>
        </el-form>
        <div style="height:100px"></div>
        <div
            style="    position: absolute;
    bottom: 0px;
    left: 0px;
"
        >
          <el-image style=" " :src="require(`@/assets/img/bottomimg.png`)"
                    :preview-src-list="[require(`@/assets/img/bottomimg.png`)]" fit="scale-down">
            <div slot="error" class="image-slot" style="text-align: center">
              <i class="el-icon-picture-outline" style="font-size: 46px"></i>
            </div>
          </el-image>
        </div>
      </el-col>
    </el-row>
  </el-container>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          resdata: {},
        };
      },
    },
  },
  data() {
    return {
      srcurl: this.$base.dv + "/api/out/qrcodescantemplate/findcontentpic?picUrl=",
      //接口参数
      packageLevel: false,
      imgsrc: "data:image/png;base64,",
      qrcode: "",
      qlist: [],
      formlist: {
        extendList: [],
        wlist: [],
      },
      link2: "javascript:;",
      // 全屏css
      parent: {
        backgroundColor: "red",
        height: "100%",
      },
      footer: {
        height: "220px",
      },
      // 基础数据
      src: [],
      dialogVisible: false,
      Visible: false,
      information: null,
      informationarr: null,
      wlistshow: false,
      obj: {},
      photo2: require("@/assets/img/3.png"),
      content: "",
      productimg: false,
    };
  },
  mounted() {
    // this.getheight();
    this.formlistget();
  },
  methods: {
    // 获取url参数
    // 获取浏览器高度
    getheight() {
      this.$data.parent.height = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) + "px";
      console.log(this.parent.height);
    },
    // 跟据链接参数调接口 100001522019091710010000561V06GT12
    formlistget() {
      var response = this.data.resdata;
      this.formlist = response.data;
      if (this.formlist.ifForgery) {
        this.dialogVisible = true;
      } else {
        this.Visible = true;
      }
      if (response.data.packageLevel == 2) {
        this.packageLevel = true;
      }

      console.log(this.formlist);
      // if (this.formlist.qrcodeFlows===null ? false:this.formlist.qrcodeFlows.length>0) {
      //   for (let i = 0; i < this.formlist.qrcodeFlows.length; i++) {
      //     switch (this.formlist.qrcodeFlows[i].type) {
      //       case 0:
      //         this.formlist.qrcodeFlows[i].type = "调拨出库";
      //         break;
      //       case 1:
      //         this.formlist.qrcodeFlows[i].type = "销售出库";
      //         break;
      //       case 2:
      //         this.formlist.qrcodeFlows[i].type = "出库单退货";
      //         break;
      //       case 3:
      //         this.formlist.qrcodeFlows[i].type = "借货出库";
      //         break;
      //       case 4:
      //         this.formlist.qrcodeFlows[i].type = "调拨入库";
      //         break;
      //       case 5:
      //         this.formlist.qrcodeFlows[i].type = "入库";
      //         break;
      //       case 6:
      //         this.formlist.qrcodeFlows[i].type = " 经销商入库";
      //         break;
      //       case 7:
      //         this.formlist.qrcodeFlows[i].type = "经销商跨级入库";
      //         break;
      //       case 8:
      //         this.formlist.qrcodeFlows[i].type = "拒收退货";
      //         break;
      //       case 9:
      //         this.formlist.qrcodeFlows[i].type = "销售退货";
      //         break;
      //       default:
      //         break;
      //     }
      //   }
      // }

      for (let i = 0; i < this.formlist.qlist.length; i++) {
        if (this.formlist.qlist[i].link == "") {
          this.formlist.qlist[i].link = "javascript:;";
        }
        switch (this.formlist.qlist[i].type) {
          case 3:
            this.src.push({
              url: this.formlist.qlist[i].content,
              link: this.formlist.qlist[i].link,
            });
            break;
          default:
            break;
        }
        switch (this.formlist.qlist[i].templateOrder) {
          case 2:
            this.content = this.formlist.qlist[i].content;
            break;
          case 3:
            this.photo2 = this.formlist.qlist[i].content;
            this.link2 = this.formlist.qlist[i].link;
            break;
          default:
            break;
        }
      }
      if (this.formlist.productPic) {
        this.productimg = true;
      }
      console.log(this.formlist.qlist[0]);
      // this.src = this.srcurl + this.formlist.qlist[0].content;
      this.information = this.formlist.qlist[this.formlist.qlist.length - 1];
      this.informationarr = this.information.content.split(",");
      for (var i = 0; i < this.informationarr.length; i++) {
        var split = this.informationarr[i].split(":");
        this.obj[split[0].trim()] = split[1].trim();
      }
      if (this.formlist.wlist.length > 0) {
        this.wlistshow = true;
      }
    },
  },
};
</script>
<style scoped>
/* 深度选择器，修改el-container最外层 */
:deep(.el-row) {
  background-color: transparent !important;
}


.yuanred {
  width: 15px;
  height: 15px;
  border-radius: 20px;
  background-color: #e60012;
  display: inline-block;
  margin-right: 10px;
}

.titleyuan {
  display: flex;
  font-weight: bold;
  color: #2c2b2b;
  align-items: center;
  margin: 10px 0;
}

.imfodiv {
  background-color: #fff; /* 这个是卡片白底，保留，业务需要 */
  color: #696969;
  border-radius: 20px;
  margin: 20px 0;
  padding: 20px;
}

.leftyuan {
  width: 25px;
  height: 46px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  background-color: red;
}

.rightyuan {
  width: 25px;
  height: 46px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  background-color: red;
}

.dashed-border {
  border: 1px dashed red;
  width: 100%;
  height: 0px;
  margin-top: 23px;
}

.mainform {
  height: 60%;
}

.el-main {
  padding: 5px 20px 15px;
}

.suyuan {
  margin-top: 15px;
  padding: 5px 20px;
  background-color: #fff; /* 卡片白底保留 */
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}

.suyuan2 {
  padding: 5px 20px;
  background-color: #fff; /* 卡片白底保留 */
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.el-header {
  height: 40px !important;
  font-size: 20px;
  background-color: #03a9f4;
  color: aliceblue;
  text-align: center;
  line-height: 40px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.el-footer {
  height: auto !important;
  margin-bottom: 0px;
  padding: 0 0px;
}

.el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}

.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.hater {
  font-size: 14px;
  background-color: red;
  color: #fff;
  padding: 4px 15px;
  border-radius: 20px;
  margin-top: 10px;
  display: inline-block;
}

.el-divider--horizontal {
  margin: 10px 0;
}

.text {
  font-size: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  margin: 10px 0;
  width: 100%;
}

.label_color_size .el-form-item__label {
  font-size: 18px;
  color: #52acff;
}

a {
  -webkit-tap-highlight-color: transparent;
  outline: none;
}
</style>
